module.exports = __webpack_public_path__ + "static/media/brickred.2bc1cfe9.png";